<template>
  <select-form
    :name="fieldName"
    :validator="validator"
    :dispatcher="dispatcher"
    :selectable-items="employmentTypes"
    :default-item="defaultItem"
  />
</template>

<script setup>
import {
  useEmploymentTypeField,
  useEmploymentTypeStore
} from "@component_path/agent_selection_wish_module/custom_hook/EmploymentType";

import SelectForm from "@component_path/pages/pc/agent_selection/secret/components/form_element/Select";

const props = defineProps({
  required: {
    type: Boolean,
    required: false,
    default: false
  },
  defaultItem: {
    type: Object,
    required: false
  }
});

const { validator, fieldName } = useEmploymentTypeField(props.required);
const { employmentTypes, dispatcher } = useEmploymentTypeStore();
</script>
